import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PageVideo } from './page-video';

@NgModule({
  declarations: [
    PageVideo,
  ],
  imports: [
    IonicPageModule.forChild(PageVideo),
  ],
  exports: [
    PageVideo
  ]
})
export class PageVideoModule {}



// WEBPACK FOOTER //
// ./src/pages/page-video/page-video.module.ts